/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:768px){[_nghost-%COMP%]     .mat-form-field{width:100%!important;min-width:250px!important}}"];
export { styles as styles };
